import React from 'react';

export default function AtsTableSkeleton({ columns = 6, rows = 8 }) {
	return (
		<tbody className="ats-table-skeleton" aria-hidden="true">
			{Array.from({ length: rows }).map((_, rowIndex) => (
				<tr key={`ats-skeleton-row-${rowIndex}`}>
					{Array.from({ length: columns }).map((__, colIndex) => (
						<td key={`ats-skeleton-cell-${rowIndex}-${colIndex}`}>
							<span
								className="ats-table-skeleton-bar"
								style={{ width: colIndex === 0 ? '70%' : '46%' }}
							/>
						</td>
					))}
				</tr>
			))}
		</tbody>
	);
}
